/**
 * Returns the regional subdomain service URL. This is the same logic used by
 * getSubdomainServiceEndpoint for the regional path (https://{subdomain}.{regionAlias.}{baseUrl}).
 *
 * @param subdomain - Subdomain (e.g. ExtendSubdomainService.APP_PREVIEW or LOCAL_APP_PREVIEW)
 * @param baseUrl - Base host (e.g. SUBDOMAIN_API_BASE_URL)
 * @param regionAlias - Optional region alias without leading dot (e.g. 's0015')
 */
export const getSubdomainServiceUrl = (subdomain: string, baseUrl: string, regionAlias?: string): string => {
  const regionPart = regionAlias ? `${regionAlias}.` : '';
  return `https://${subdomain}.${regionPart}${baseUrl}`;
};
